/**
 * Chuẩn hóa cờ confirm_order trên proxy Shopee (BE không còn auto confirm mặc định).
 *
 * - Không gửi gì / mặc định: BE bỏ qua confirm_order — chỉ ship khi đã READY_TO_SHIP / RETRY_SHIP.
 * - confirmOrderBeforeShip: true — giữ hành vi cũ (thử confirm với UNPAID, …).
 * - skipConfirmOrder: có mặt → BE tuân thủ tuyệt đối; false = cho phép nhánh confirm.
 * - forceConfirmOrder: chỉ có ý nghĩa khi nhánh confirm được bật (confirmOrderBeforeShip hoặc skipConfirmOrder: false).
 *
 * @param {object} options
 * @param {boolean} [options.confirmOrderBeforeShip]
 * @param {boolean} [options.forceConfirmOrder]
 * @returns {Record<string, boolean>}
 */
export function buildShopeeConfirmOrderPayload(options = {}) {
  const confirmOrderBeforeShip = !!options.confirmOrderBeforeShip
  const forceConfirmOrder = !!options.forceConfirmOrder

  if (confirmOrderBeforeShip) {
    const out = { confirmOrderBeforeShip: true }
    if (forceConfirmOrder) {
      out.forceConfirmOrder = true
    }
    return out
  }

  if (forceConfirmOrder) {
    return {
      skipConfirmOrder: false,
      forceConfirmOrder: true,
    }
  }

  return { skipConfirmOrder: true }
}
